import { isDefined } from "@clipboard-health/util-ts";
import { OpenGeoLocationBottomSheet } from "@src/appV2/redesign/OpenGeoLocation/OpenGeoLocationBottomSheet";
import { useOpenGeoLocationContext } from "@src/appV2/redesign/OpenGeoLocation/useOpenGeoLocation";
import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { parseISO } from "date-fns";

import { WorkerShiftDetailsArrivalTimeCard } from "./Card";

interface WorkerShiftDetailsArrivalTimeCardContainerProps {
  shift: Shift;
}

export function WorkerShiftDetailsArrivalTimeCardContainer(
  props: WorkerShiftDetailsArrivalTimeCardContainerProps
) {
  const { shift } = props;

  const { onClick: onGetDirections, href: googleMapsHref } = useOpenGeoLocationContext();

  const { targetArrivalTime, shiftStartAt } = shift.computedArrival!;
  const timezone = shift.facility.tmz ?? "America/Los_Angeles";

  return (
    <>
      <WorkerShiftDetailsArrivalTimeCard
        startDatetime={parseISO(shiftStartAt)}
        targetArrivalTime={parseISO(targetArrivalTime)}
        workplaceTimezone={timezone}
        onGetDirections={() => {
          if (isDefined(onGetDirections)) {
            onGetDirections();
          } else {
            window.open(googleMapsHref, "_blank");
          }
        }}
      />
      <OpenGeoLocationBottomSheet />
    </>
  );
}
